var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12V0H12V12H0ZM9.87495 3.54L7.19995 5.59C6.92995 5.795 6.92995 6.205 7.19995 6.415L9.87495 8.465L8.45996 9.88L6.40995 7.205C6.19995 6.935 5.79496 6.935 5.58495 7.205L3.53495 9.88L2.11995 8.465L4.79496 6.415C5.06495 6.205 5.06495 5.795 4.79496 5.59L2.11995 3.54L3.53495 2.125L5.58495 4.8C5.79496 5.07 6.19995 5.07 6.40995 4.8L8.45996 2.125L9.87495 3.54Z",
    fill: "#9E0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error-icon.cae2c44862f30c52fd2ffd7e0415a440.svg";
export { ForwardRef as ReactComponent };